const hero = () => {
  const heroTitle = document.querySelector('.c-hero__title');
  if (heroTitle) {
    document.querySelector('body').classList.add('has-hero');
    const heroColor = window
      .getComputedStyle(heroTitle)
      .getPropertyValue('color');
    const breadcrumbsItems = document.querySelectorAll('.c-breadcrumbs *');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < breadcrumbsItems.length; i++) {
      breadcrumbsItems[i].style.color = heroColor;
    }
  }
};

export default hero;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/hero.js